/* eslint-disable rulesdir/no-unresolved-theme-attributes */
import styled from 'styled-components';
import theme from './SecondaryButton.theme';

export const SecondaryButton = styled('span')`
  & .baseButton.secondaryButton {
    background: ${props => theme(props).background};
    border: 0.0625rem solid ${props => theme(props).border};
    border-radius: ${props => theme(props).radius};
    box-shadow: 0 o.3125rem 0.625rem 0 rgba(0, 0, 0, 0.16);
    color: ${props => theme(props).text};
    min-width: 9.8125rem;

    &:hover {
      background: ${props => theme(props).background};
      border-color: ${props => theme(props).focusBorder};
      color: ${props => theme(props).hoverText};

      /* stylelint-disable-next-line */
      & .loadingSpinner svg {
        color: ${props => theme(props).background};
      }
    }

    &:focus {
      background: ${props => theme(props).background};
      border-color: ${props => theme(props).focusBorder};
      color: ${props => theme(props).hoverText};
    }

    &:disabled {
      background: ${props => theme(props).background};
      cursor: not-allowed;
      opacity: 0.6;
      pointer-events: none;
    }

    /* stylelint-disable-next-line */
    & .loadingSpinner svg {
      color: ${props => theme(props).background};
    }
  }
`;
